import { Classes, Popover } from '../components/ui/popover'
import classNames from 'classnames'
import React, { useMemo, useState } from 'react'
import { Button } from '../components/ui/button'

export const FilterIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="16"
            viewBox="0 0 21 16"
            fill="none"
            {...props}
        >
            <path
                d="M3 0.5H1.85801L2.6326 1.33914L8.5 7.69549V14V14.809L9.22361 14.4472L12.2236 12.9472L12.5 12.809V12.5V7.69549L18.3674 1.33914L19.142 0.5H18H3Z"
                stroke="#3391FF"
            />
        </svg>
    )
}

export const SearchIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                d="M10.5781 10.5781L15.0002 15.0002"
                stroke="#3391FF"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.6055 12.211C9.70133 12.211 12.211 9.70133 12.211 6.6055C12.211 3.50967 9.70133 1 6.6055 1C3.50967 1 1 3.50967 1 6.6055C1 9.70133 3.50967 12.211 6.6055 12.211Z"
                stroke="#3391FF"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const BulkActionsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                d="M1 1H3.8V3.8H1V1ZM6.6 1H9.4V3.8H6.6V1ZM12.2 1H15V3.8H12.2V1ZM1 12.2H3.8V15H1V12.2Z"
                stroke="#3391FF"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.59961 12.1992H9.39961V14.9992H6.59961V12.1992ZM12.1996 12.1992H14.9996V14.9992H12.1996V12.1992Z"
                stroke="#3391FF"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.59961 6.59766H9.39961V9.39766H6.59961V6.59766ZM12.1996 6.59766H14.9996V9.39766H12.1996V6.59766Z"
                stroke="#3391FF"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1 6.59766H3.8V9.39766H1V6.59766Z"
                stroke="#3391FF"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const SettingsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="24"
            fill="#899CB3"
        >
            <path d="m416-132-14-112q-21-6-46.5-20T313-294l-103 44-64-112 89-67q-2-12-3.5-25t-1.5-25q0-11 1.5-23.5T235-531l-89-67 64-110 102 43q20-17 43.5-30.5T401-716l15-112h128l14 113q26 9 45.5 20.5T644-665l106-43 64 110-93 70q4 14 4.5 25.5t.5 22.5q0 10-1 21.5t-4 28.5l91 68-64 112-104-45q-21 18-42 30.5T558-245l-14 113H416Zm62-260q37 0 62.5-25.5T566-480q0-37-25.5-62.5T478-568q-37 0-62.5 25.5T390-480q0 37 25.5 62.5T478-392Zm0-28q-25 0-42.5-17.5T418-480q0-25 17.5-42.5T478-540q25 0 42.5 17.5T538-480q0 25-17.5 42.5T478-420Zm2-60Zm-40 320h78l15-109q30-8 53.5-21.5T636-329l100 43 40-68-88-66q5-18 6.5-32t1.5-28q0-15-1.5-28t-6.5-30l90-68-40-68-103 43q-17-19-47.5-37T532-691l-12-109h-80l-12 108q-30 6-55 20t-51 40l-100-42-40 68 87 65q-5 13-7 29t-2 33q0 15 2 30t6 29l-86 66 40 68 99-42q24 24 49 38t57 22l13 108Z" />
        </svg>
    )
}

export const HistoryIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="24"
            fill="#899CB3"
        >
            <path d="M478-172q-117 0-204-76T173-440h28q17 103 94.5 171.5T478-200q117 0 198.5-81.5T758-480q0-117-81.5-198.5T478-760q-60 0-113 24.5T270-668h96v28H222v-144h28v96q45-47 104-73.5T478-788q64 0 120 24t98 66q42 42 66 98t24 120q0 64-24 120t-66 98q-42 42-98 66t-120 24Zm133-158L467-474v-206h28v194l136 136-20 20Z" />
        </svg>
    )
}

export const ColumnsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="16"
            viewBox="0 0 15 16"
            fill="none"
        >
            <path
                d="M5.1658 1V15M5.1658 5.66667H14.4991M5.1658 10.3333H14.4991"
                stroke="#3391FF"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M0.5 1H14.5V15H0.5V1Z"
                stroke="#3391FF"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const CalendarIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 -960 960 960"
            fill="#3391FF"
        >
            <path
                d="M306-394q-17 0-28.5-11.5T266-434q0-17 11.5-28.5T306-474q17 0 28.5 11.5T346-434q0 17-11.5 28.5T306-394Zm177 0q-17 0-28.5-11.5T443-434q0-17 11.5-28.5T483-474q17 0 28.5 11.5T523-434q0 17-11.5 28.5T483-394Zm170 0q-17 0-28.5-11.5T613-434q0-17 11.5-28.5T653-474q17 0 28.5 11.5T693-434q0 17-11.5 28.5T653-394ZM180-80q-24 0-42-18t-18-42v-620q0-24 18-42t42-18h65v-60h65v60h340v-60h65v60h65q24 0 42 18t18 42v620q0 24-18 42t-42 18H180Zm0-60h600v-430H180v430Zm0-490h600v-130H180v130Zm0 0v-130 130Z"
                stroke="#3391FF"
            />
        </svg>
    )
}

export const CSVIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 -960 960 960">
            <path d="M221-357h127v-50H238v-146h110v-50H221q-14.025 0-23.512 9.775Q188-583.45 188-569v179q0 14.025 9.488 23.513Q206.975-357 221-357Zm166 0h137q14.025 0 23.513-9.487Q557-375.975 557-390v-78q0-13-9.487-22-9.488-9-23.513-9h-87v-54h120v-50H420q-14.025 0-23.513 9.487Q387-584.025 387-570v78q0 14 9.487 23.5Q405.975-459 420-459h87v52H387v50Zm271 0h57l75-246h-50l-53 183-47-183h-50l68 246ZM140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm0-60h680v-520H140v520Zm0 0v-520 520Z" />
        </svg>
    )
}

export const ContextIcon = ({ asButton = false }) => {
    const iconClassName = classNames('cursor-pointer font-bold text-mjDark-1400 text-lg')

    const icon = <span className={iconClassName}>···</span>

    if (asButton) {
        return <Button minimal icon={icon} />
    } else {
        return icon
    }
}

export const EllipsisMenu = ({
    asButton = false,
    content,
}: {
    asButton?: boolean
    content: string | JSX.Element
}) => {
    return (
        <Popover
            interactionKind="click"
            position="bottom-left"
            // popoverClassName={Classes.POPOVER2_CONTENT_SIZING + ' w-40'}
            content={content}
        >
            <ContextIcon asButton={asButton} />
        </Popover>
    )
}

export interface IconProps {
    isActive?: boolean
    height?: React.SVGProps<SVGSVGElement>['height']
    width?: React.SVGProps<SVGSVGElement>['width']
    activeColor?: string
}

export const DashboardIcon = ({ isActive = false, height = 18, width = 16.5 }: IconProps) => {
    const color = isActive ? '#33DAFF' : '#899CB3'
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1 4.11111C1 2.39289 2.39289 1 4.11111 1H8.77778C10.496 1 11.8889 2.39289 11.8889 4.11111V5.66667C11.8889 7.38489 10.496 8.77778 8.77778 8.77778H4.11111C2.39289 8.77778 1 7.38489 1 5.66667V4.11111Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1 18.1111C1 16.3929 2.39289 15 4.11111 15H8.77778C10.496 15 11.8889 16.3929 11.8889 18.1111V25.8889C11.8889 27.6071 10.496 29 8.77778 29H4.11111C2.39289 29 1 27.6071 1 25.8889V18.1111Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.1111 4.11111C18.1111 2.39289 19.504 1 21.2222 1H25.8889C27.6071 1 29 2.39289 29 4.11111V11.8889C29 13.6071 27.6071 15 25.8889 15H21.2222C19.504 15 18.1111 13.6071 18.1111 11.8889V4.11111Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.1111 24.3333C18.1111 22.6151 19.504 21.2222 21.2222 21.2222H25.8889C27.6071 21.2222 29 22.6151 29 24.3333V25.8889C29 27.6071 27.6071 29 25.8889 29H21.2222C19.504 29 18.1111 27.6071 18.1111 25.8889V24.3333Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const AutomationsIcon = ({
    isActive = false,
    height = 18,
    width = 16.5,
    activeColor = '#33FF47',
}: IconProps) => {
    const color = isActive ? activeColor : '#899CB3'
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 28 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16 1L1 22H11L12 37L27 16H17L16 1Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const SegmentsIcon = ({
    isActive = false,
    height = 22,
    width = 22,
    activeColor = '#FF3333',
}: IconProps) => {
    const color = isActive ? activeColor : '#899CB3'
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M23.205 20.295C23.4159 20.5057 23.7019 20.624 24 20.624C24.2981 20.624 24.5841 20.5057 24.795 20.295L32.295 12.795C32.5057 12.584 32.624 12.2981 32.624 12C32.624 11.7019 32.5057 11.4159 32.295 11.205L24.795 3.70499C24.5841 3.49431 24.2981 3.37598 24 3.37598C23.7019 3.37598 23.4159 3.49431 23.205 3.70499L15.705 11.205C15.4943 11.4159 15.376 11.7019 15.376 12C15.376 12.2981 15.4943 12.584 15.705 12.795L23.205 20.295ZM24 6.09186L29.9081 12L24 17.9081L18.0919 12L24 6.09186ZM24.795 27.705C24.5841 27.4943 24.2981 27.376 24 27.376C23.7019 27.376 23.4159 27.4943 23.205 27.705L15.705 35.205C15.4943 35.4159 15.376 35.7019 15.376 36C15.376 36.2981 15.4943 36.584 15.705 36.795L23.205 44.295C23.4159 44.5057 23.7019 44.624 24 44.624C24.2981 44.624 24.5841 44.5057 24.795 44.295L32.295 36.795C32.5057 36.584 32.624 36.2981 32.624 36C32.624 35.7019 32.5057 35.4159 32.295 35.205L24.795 27.705ZM44.295 23.205L36.795 15.705C36.5841 15.4943 36.2981 15.376 36 15.376C35.7019 15.376 35.4159 15.4943 35.205 15.705L27.705 23.205C27.4943 23.4159 27.376 23.7019 27.376 24C27.376 24.2981 27.4943 24.584 27.705 24.795L35.205 32.295C35.4159 32.5057 35.7019 32.624 36 32.624C36.2981 32.624 36.5841 32.5057 36.795 32.295L44.295 24.795C44.5057 24.584 44.624 24.2981 44.624 24C44.624 23.7019 44.5057 23.4159 44.295 23.205ZM36 29.9081L30.0919 24L36 18.0919L41.9081 24L36 29.9081ZM20.295 23.205L12.795 15.705C12.5841 15.4943 12.2981 15.376 12 15.376C11.7019 15.376 11.4159 15.4943 11.205 15.705L3.705 23.205C3.49433 23.4159 3.37599 23.7019 3.37599 24C3.37599 24.2981 3.49433 24.584 3.705 24.795L11.205 32.295C11.4159 32.5057 11.7019 32.624 12 32.624C12.2981 32.624 12.5841 32.5057 12.795 32.295L20.295 24.795C20.5057 24.584 20.624 24.2981 20.624 24C20.624 23.7019 20.5057 23.4159 20.295 23.205ZM12 29.9081L6.09188 24L12 18.0919L17.9081 24L12 29.9081Z"
                fill={color}
            />
        </svg>
    )
}

export const ToolsIcon = ({
    isActive = false,
    height = 18,
    width = 18,
    activeColor = '#33FF47',
}: IconProps) => {
    const color = isActive ? activeColor : '#899CB3'
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.106-3.105c.32-.322.863-.22.983.218a6 6 0 0 1-8.259 7.057l-7.91 7.91a1 1 0 0 1-2.999-3l7.91-7.91a6 6 0 0 1 7.057-8.259c.438.12.54.662.219.984z"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const AdManageIcon = ({ isActive = false, height = 18, width = 16.5 }: IconProps) => {
    const color = isActive ? '#E233FF' : '#899CB3'
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 38 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M35 16.2917L37 17.2917L20.7889 25.3973C19.6627 25.9604 18.3373 25.9604 17.2111 25.3973L1 17.2917L3 16.2917M35 24.2917L37 25.2917L20.7889 33.3973C19.6627 33.9604 18.3373 33.9604 17.2111 33.3973L1 25.2917L3 24.2917M1 9.2918L16.3167 1.63344C18.0059 0.788854 19.9941 0.788855 21.6833 1.63344L37 9.2918L21.6833 16.9502C19.9941 17.7947 18.0059 17.7947 16.3167 16.9502L1 9.2918Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const CompassIcon = ({ isActive = true, height = 18, width = 16.5 }) => {
    const color = isActive ? '#28CCB0' : '#899CB3'
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                d="M4.58849 11.4115L9.06922 9.07943L11.4013 4.59868L6.92052 6.93073L4.58849 11.4115ZM8 8.66661C7.81111 8.66661 7.65278 8.60272 7.525 8.47494C7.39723 8.34717 7.33334 8.18883 7.33334 7.99994C7.33334 7.81105 7.39723 7.65272 7.525 7.52494C7.65278 7.39717 7.81111 7.33328 8 7.33328C8.18889 7.33328 8.34723 7.39717 8.475 7.52494C8.60278 7.65272 8.66667 7.81105 8.66667 7.99994C8.66667 8.18883 8.60278 8.34717 8.475 8.47494C8.34723 8.60272 8.18889 8.66661 8 8.66661ZM8.00112 14.3333C7.132 14.3333 6.31313 14.167 5.5445 13.8346C4.77588 13.5021 4.10372 13.0482 3.52802 12.4728C2.95231 11.8973 2.49816 11.2254 2.16557 10.4572C1.83298 9.68887 1.66669 8.87017 1.66669 8.00106C1.66669 7.1251 1.83291 6.30175 2.16535 5.53099C2.4978 4.76023 2.95174 4.08977 3.52719 3.51963C4.10264 2.94947 4.77451 2.4981 5.54279 2.16551C6.31108 1.83292 7.12978 1.66663 7.99889 1.66663C8.87484 1.66663 9.6982 1.83285 10.469 2.16529C11.2397 2.49774 11.9102 2.9489 12.4803 3.51879C13.0505 4.08869 13.5018 4.75885 13.8344 5.52928C14.167 6.29969 14.3333 7.12287 14.3333 7.99883C14.3333 8.86795 14.1671 9.68682 13.8347 10.4554C13.5022 11.2241 13.051 11.8962 12.4812 12.4719C11.9113 13.0476 11.2411 13.5018 10.4707 13.8344C9.70026 14.167 8.87708 14.3333 8.00112 14.3333ZM8 13.5769C9.55214 13.5769 10.8697 13.0337 11.9526 11.9474C13.0355 10.8611 13.5769 9.54524 13.5769 7.99994C13.5769 6.44781 13.0355 5.13029 11.9526 4.04738C10.8697 2.96448 9.55214 2.42303 8 2.42303C6.4547 2.42303 5.13889 2.96448 4.05257 4.04738C2.96625 5.13029 2.42309 6.44781 2.42309 7.99994C2.42309 9.54524 2.96625 10.8611 4.05257 11.9474C5.13889 13.0337 6.4547 13.5769 8 13.5769Z"
                fill={color}
            />
        </svg>
    )
}
